import { useEffect } from 'react';
import { useAuth0 } from '@brighte/passwordless-authenticator';
import { VerticalStepper } from '@spark-web/vertical-stepper';
import PageTitle from '../../components/PageTitle/PageTitle';
import Step from '../../components/Step/Step';
import DeclinedApplication from './DeclinedApplication';
import { useGetNextStepIndex, useGetStatusSteps } from './hooks';
import { ApplicationSubmissionStatus, StepType } from './types';

type NextStepsProps = {
  readonly status: ApplicationSubmissionStatus;
};

function NextSteps({ status }: NextStepsProps) {
  const steps = useGetStatusSteps(status);
  const activeStep = useGetNextStepIndex(steps, status);
  const { clearCredentials } = useAuth0();

  useEffect(() => {
    clearCredentials();
  }, []);

  if (status === ApplicationSubmissionStatus.DECLINED) {
    return <DeclinedApplication />;
  }
  return (
    <>
      <PageTitle status={status} />
      <VerticalStepper activeIndex={activeStep}>
        {steps.map((step: StepType) => (
          <Step {...step} key={step.title} />
        ))}
      </VerticalStepper>
    </>
  );
}

export default NextSteps;
